module.exports = __webpack_public_path__ + "media/pressalit_2.fcd76847.mp4";